import React from "react";
import { Modal } from "@mui/material";
import { Grid } from "@mui/material";
import Controls from "../../core/Controls/Controls";
import "./ActivityLogs.scss";
import { CollapsibleJSON } from "../../core/BaseComponents/JSONViewer";

const ActivityLogsPopup = (props) => {
  const { rowData } = props;

  return (
    <Modal
      open={props?.isOpen}
      onClose={() => props.onClose()}
      className="basic-modal"
    >
      <div className="basic-modal_root col-7">
        <Grid item xs={12} className="flex-item">
          <div className="me-1 col-6">
            <label>
              <strong>Old Value:</strong>
            </label>
            {/* <Controls.Input
              className="col-12 stack-trace"
              name={"StackTrace"}
              // label={'Stack Trace'}
              value={rowData?.oldJson}
              disabled={true}
              multiline
            /> */}
            <CollapsibleJSON
              data={JSON.parse(rowData?.oldJson ? rowData?.oldJson : "{}")}
            />
          </div>
          <div className="ms-1 col-6">
            <label>
              <strong>New Value:</strong>
            </label>
            {/* <Controls.Input
              className="col-12 stack-trace"
              name={"StackTrace"}
              // label={'Stack Trace'}
              value={rowData?.newJson}
              disabled={true}
              multiline
            /> */}
            <CollapsibleJSON
              data={JSON.parse(rowData?.newJson ? rowData?.newJson : "{}")}
            />
          </div>
        </Grid>
        <div className="flex-items-center mt-2">
          <button onClick={() => props.onClose()} className={`create-btn `}>
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ActivityLogsPopup;
